import Vue from "vue";
import config from "@/configs/config";

var _this = Vue.prototype;

var xs = {};

var objectToQueryString = function (object) {
    var queryStringArray = [];
    for (var key in object) {
        if (object.hasOwnProperty(key)) {
            queryStringArray.push(encodeURIComponent(key) + "=" + encodeURIComponent(object[key]));
        }
    }
    return queryStringArray.join("&");
}

xs.request = function (object) {
    var url = object.url || "";
    var data = object.data || {};
    var header = object.header || {};
    var method = object.method || "GET";
    var success = object.success || null;
    var fail = object.fail || null;
    var complete = object.complete || null;

    var response = {};

    var xhr = new XMLHttpRequest();

    xhr.onerror = function () {
        response.errMsg = "request:fail";
        if (typeof fail === "function") {
            fail(response);
        }
        if (typeof complete === "function") {
            complete(response);
        }
    };

    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
            response.errMsg = "request:ok";
            response.statusCode = xhr.status;
            try {
                response.data = JSON.parse(xhr.response);
            } catch (e) {
                response.data = xhr.response;
            }
            if (typeof success === "function") {
                success(response);
            }
            if (typeof complete === "function") {
                complete(response);
            }
        }
    };

    if (method.toUpperCase() === "GET") {
        if (data) {
            xhr.open(method, url + "?" + objectToQueryString(data));
        } else {
            xhr.open(method, url);
        }
        for (var key in header) {
            if (header.hasOwnProperty(key)) {
                xhr.setRequestHeader(key, header[key]);
            }
        }
        xhr.send();
    } else if (method.toUpperCase() === "POST") {
        xhr.open(method, url);
        for (var key in header) {
            if (header.hasOwnProperty(key)) {
                xhr.setRequestHeader(key, header[key]);
            }
        }
        xhr.send(objectToQueryString(data));
    }
};

var request = function (url, method, data) {
    return new Promise(function (resolve, reject) {
        _this.$toast.loading({
            message: "数据加载中...",
            forbidClick: true
        });
        xs.request({
            url: config.requestBaseUrl + url,
            data: data,
            header: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            method: method,
            success: function (res) {
                _this.$toast.clear();
                console.log("[xs.request:success]\n" + "url:" + config.requestBaseUrl + url + "\n" + "data:" + JSON.stringify(data) + "\n" + "method:" + method + "\n" + "res:" + JSON.stringify(res) + "\n");
                if (res.statusCode >= 200 && res.statusCode < 300 || res.statusCode === 304) {
                    if (res.data.responseCode == 0) {
                        resolve(res.data);
                    } else {
                        _this.$toast("" + res.data.responseMessage);
                        reject(res);
                    }
                } else {
                    _this.$toast("获取数据失败！");
                    reject(res);
                }
            },
            fail: function (res) {
                _this.$toast.clear();
                console.log("[xs.request:fail]\n" + "url:" + config.requestBaseUrl + url + "\n" + "data:" + JSON.stringify(data) + "\n" + "method:" + method + "\n" + "res:" + JSON.stringify(res) + "\n");
                _this.$toast("获取数据失败！");
                reject(res);
            }
        });
    });
};


var api = {
    getCityList: function (data) {
        var url = "api/city/getCityList";
        var method = "GET";
        return request(url, method, data);
    },
    getCity: function (data) {
        var url = "api/city/getCity";
        var method = "GET";
        return request(url, method, data);
    },
    getArticleList: function (data) {
        var url = "api/article/getArticleList";
        var method = "GET";
        return request(url, method, data);
    },
    getArticle: function (data) {
        var url = "api/article/getArticle";
        var method = "GET";
        return request(url, method, data);
    },
    addOrder: function (data) {
        var url = "api/order/addOrder";
        var method = "POST";
        return request(url, method, data);
    }
};

export default api;
